import React from 'react';
import { FaDownload, FaFilter, FaUpload, FaCalendarAlt } from 'react-icons/fa';
import { useTranslation } from '../../../context/LanguageContext';

const OrderActions = ({
    onExport,
    onToggleFilters,
    showFilters,
    bulkDate,
    onBulkDateChange,
    onBulkUpload,
    bulkUploading
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 sm:mb-6 gap-4 lg:gap-0 w-full">
            <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 truncate flex-shrink-0">
                {t('admin.title')}
            </h1>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full lg:w-auto items-stretch sm:items-center flex-shrink-0">
                <button
                    onClick={onToggleFilters}
                    className={`px-4 py-2 rounded-lg flex items-center justify-center sm:justify-start gap-2 transition-all duration-200 w-full sm:w-auto
                        ${showFilters 
                            ? 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200' 
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                >
                    <FaFilter className="w-4 h-4" />
                    <span className="text-sm sm:text-base">{t('admin.filters_title')}</span>
                </button>
                {/* Bulk Upload by Date */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 bg-gray-50 p-2 sm:p-3 rounded-lg w-full sm:w-auto">
                    <div className="flex items-center gap-2 w-full sm:w-auto">
                        <FaCalendarAlt className="text-gray-600 w-4 h-4 flex-shrink-0" />
                        <input
                            type="date"
                            value={bulkDate || ''}
                            onChange={(e) => onBulkDateChange && onBulkDateChange(e.target.value)}
                            className="border border-gray-300 rounded px-2 py-1 text-sm w-full sm:w-auto"
                        />
                    </div>
                    <button
                        onClick={onBulkUpload}
                        disabled={!bulkDate || bulkUploading}
                        className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 transition-all duration-200 text-white w-full sm:w-auto text-sm sm:text-base ${(!bulkDate || bulkUploading) ? 'bg-gray-300 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-600 transform hover:scale-105'}`}
                        title="Upload all invoices for selected date"
                    >
                        {bulkUploading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-1 w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg>
                                {t('admin:uploading') || 'Uploading…'}
                            </>
                        ) : (
                            <>
                                <FaUpload className="w-4 h-4" />
                                <span className="hidden sm:inline">{t('admin:bulk_upload') || 'Bulk Upload ZATCA'}</span>
                                <span className="sm:hidden">Upload</span>
                            </>
                        )}
                    </button>
                </div>
                <button
                    onClick={onExport}
                    className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600
                        transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2 w-full sm:w-auto text-sm sm:text-base"
                >
                    <FaDownload className="w-4 h-4" />
                    <span>{t('admin.export')}</span>
                </button>
            </div>
        </div>
    );
};

export default OrderActions;
